import { ReactNode } from 'react'

import classNames from 'classnames'

import { CommonBookmark3Icon, CommonBookmarkActive3Icon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import styles from './BookmarkButton.module.scss'

export enum ButtonBookmarkType {
  FEED = 'feed',
  LIST_MAP = 'listMap',
  DEFAULT_LIST_MAP = 'defaultListMap',
  MY_LIST_MAP = 'myListMap',
  MY_THEME = 'myTheme',
  OTHER_LIST_MAP = 'otherListMap',
  REVIEW_END = 'reviewEnd',
  THEMELIST = 'themelist',
  VISIT = 'visit',
  VISIT_DETAIL = 'visitDetail',
  REVIEW_TAB = 'reviewTab',
  REVIEW_TAB_OTHERS = 'reviewTabOthers',
  TIMELINE_LIST = 'timeline',
}

interface BookmarkProps {
  type?: ButtonBookmarkType
  isBookmarked?: boolean
  onClickBookmark?: () => void
  fromFunctionButton?: boolean
  buttonClassName?: string
  icon?: ReactNode
  iconClassName?: string
  bookmarkingClickCode?: string
  unbookmarkingClickCode?: string
}

const UIBookmarkButton = ({
  isBookmarked,
  onClickBookmark,
  type,
  fromFunctionButton = false,
  buttonClassName,
  icon,
  iconClassName,
  bookmarkingClickCode,
  unbookmarkingClickCode,
}: BookmarkProps) => {
  const BookmarkIcon = icon ? icon : isBookmarked ? CommonBookmarkActive3Icon : CommonBookmark3Icon

  return (
    <>
      <Clickable
        aria-pressed={isBookmarked}
        className={
          fromFunctionButton
            ? classNames(styles.btn, { [styles.type_bookmarked]: isBookmarked }, buttonClassName)
            : type === ButtonBookmarkType.TIMELINE_LIST
            ? classNames(styles.btn_type_timeline, buttonClassName)
            : classNames(styles.btn_type_home, buttonClassName)
        }
        onClick={onClickBookmark}
        nClickCode={isBookmarked ? unbookmarkingClickCode : bookmarkingClickCode}
      >
        <BookmarkIcon className={classNames(styles.icon, iconClassName)} aria-hidden="true" />
        <span className="place_blind">저장</span>
      </Clickable>
    </>
  )
}

export default UIBookmarkButton
